/* eslint-disable array-callback-return */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useMemo, useEffect, useState, useContext } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-table components
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
} from "react-table";

// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";

// Material Dashboard 2 PRO React example components
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import { IconButton, Menu } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";
import { TableDataContext } from "context/TableDataContext";
import MDBadge from "components/MDBadge";
import NotificationItem from "examples/Items/NotificationItem";
import axios from "axios";
import { URL_API } from "config";
import { toast } from "react-toastify";

function DataTable({
  entriesPerPage,
  canSearch,
  showTotalEntries,
  table,
  pagination,
  isSorted,
  noEndBorder,
  children,
}) {
  const { setRowAndIndex } = useContext(TableDataContext);

  const defaultValue = entriesPerPage.defaultValue
    ? entriesPerPage.defaultValue
    : 10;
  const entries = entriesPerPage.entries
    ? entriesPerPage.entries.map((el) => el.toString())
    : ["5", "10", "15", "20", "25"];
  const columns = useMemo(() => table.columns, [table]);
  const data = useMemo(() => table.rows, [table]);
  const [openMenu, setOpenMenu] = useState(false);
  const [openMenuStatus, setOpenMenuStatus] = useState(false);
  const [cooperated, setCooperated] = useState(false);
  const navigate = useNavigate();
  let tag = localStorage.getItem("Tag");

  const handleOpenMenuStatus = (event) =>
    setOpenMenuStatus(event.currentTarget);
  const handleCloseMenuStatus = () => setOpenMenuStatus(false);

  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  // Set the default value for the entries per page when component mounts
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);

  async function UpdateCooperated() {
    await axios
      .put(URL_API + `/cooperated/${cooperated?.uuid}`, cooperated, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(() => {
        handleCloseMenuStatus();
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  // Set the entries per page value based on the select value
  const setEntriesPerPage = (value) => setPageSize(value);

  // Render the paginations
  const renderPagination = pageOptions.map((option) => (
    <MDPagination
      item
      key={option}
      onClick={() => gotoPage(Number(option))}
      active={pageIndex === option}
    >
      {option + 1}
    </MDPagination>
  ));

  const renderStatus = () => (
    <Menu
      anchorEl={openMenuStatus}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenuStatus)}
      onClose={handleCloseMenuStatus}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        onClick={() => {
          cooperated.status = 1;
          UpdateCooperated();
        }}
        title="Em Aberto"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 2;
          UpdateCooperated();
        }}
        title="Iniciado"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 3;
          UpdateCooperated();
        }}
        title="Em Análise"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 8;
          UpdateCooperated();
        }}
        title="Aguardando Assinatura"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 10;
          UpdateCooperated();
        }}
        title="Finalização Cadastral"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 4;
          UpdateCooperated();
        }}
        title="Pendência Documentos"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 5;
          UpdateCooperated();
        }}
        title="Em Processo de Admissão"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 6;
          UpdateCooperated();
        }}
        title="Aprovado"
      />
      <NotificationItem
        onClick={() => {
          cooperated.status = 7;
          UpdateCooperated();
        }}
        title="Reprovado"
      />
      {/* {user.profile !== 99 && <NotificationItem
        onClick={() => {
          cooperated.status = 9;
          UpdateCooperated();
        }}
        title="Pendente Envio Empresa"
      />} */}
    </Menu>
  );

  const statusCooperatedBadge = (status) => {
    switch (status) {
      case 1:
        return <MDBadge badgeContent="Em Aberto" color="primary" container />;
      case 2:
        return <MDBadge badgeContent="Iniciado" color="default" container />;
      case 3:
        return (
          <MDBadge badgeContent="Em Análise" color="secondary" container />
        );
      case 4:
        return (
          <MDBadge
            badgeContent="Pendência Documentos"
            color="warning"
            container
          />
        );
      case 5:
        return (
          <MDBadge
            badgeContent="Em Processo de Admissão"
            color="info"
            container
          />
        );
      case 6:
        return <MDBadge badgeContent="Aprovado" color="success" container />;
      case 7:
        return <MDBadge badgeContent="Reprovado" color="error" container />;
      case 8:
        return <MDBadge badgeContent="Aguardando Assinatura" container />;
      case 9:
        return (
          <MDBadge
            badgeContent="Pendente Envio Empresa"
            color="warning"
            container
          />
        );
      case 10:
        return <MDBadge badgeContent="Finalização Cadastral" container />;
      default:
        return <MDBadge badgeContent="Em Aberto" color="primary" container />;
    }
  };

  const statusFollowUpBadge = (values, i) => {
    switch (values?.status) {
      case 1:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Em Aberto"
              color="primary"
              container
            />
            {renderStatus()}
          </>
        );
      case 2:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Iniciado"
              color="default"
              container
            />
            {renderStatus()}
          </>
        );
      case 3:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClickCapture={() => setCooperated(values)}
              onClick={handleOpenMenuStatus}
              badgeContent="Em Análise"
              color="secondary"
              container
            />
            {renderStatus()}
          </>
        );
      case 4:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClickCapture={() => setCooperated(values)}
              onClick={handleOpenMenuStatus}
              badgeContent="Pendência Documentos"
              color="warning"
              container
            />
            {renderStatus()}
          </>
        );
      case 5:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Em Processo de Admissão"
              color="info"
              container
            />
            {renderStatus()}
          </>
        );
      case 6:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Aprovado"
              color="success"
              container
            />
            {renderStatus()}
          </>
        );
      case 7:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Reprovado"
              color="error"
              container
            />
            {renderStatus()}
          </>
        );
      case 8:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Aguardando Assinatura"
              container
            />
            {renderStatus()}
          </>
        );
      case 9:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Pendente Envio Empresa"
              container
            />
            {renderStatus()}
          </>
        );
      case 10:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Finalização Cadastral"
              container
            />
            {renderStatus()}
          </>
        );
      default:
        return (
          <>
            <MDBadge
              style={{ cursor: "pointer" }}
              onClick={handleOpenMenuStatus}
              onClickCapture={() => setCooperated(values)}
              badgeContent="Em Aberto"
              color="primary"
              container
            />
            {renderStatus()}
          </>
        );
    }
  };

  const statusCompanyUserBadge = (status) => {
    switch (status) {
      case 1:
        return <MDBadge badgeContent="Ativo" color="success" container />;
      case 2:
        return <MDBadge badgeContent="Desativado" color="error" container />;

      default:
        return <MDBadge badgeContent="Ativo" color="success" container />;
    }
  };

  // Handler for the input to set the pagination index
  const handleInputPagination = ({ target: { value } }) =>
    value > pageOptions.length || value < 0
      ? gotoPage(0)
      : gotoPage(Number(value));

  // Customized page options starting from 1
  const customizedPageOptions = pageOptions.map((option) => option + 1);

  // Setting value for the pagination input
  const handleInputPaginationValue = ({ target: value }) =>
    gotoPage(Number(value.value - 1));

  // Search input value state
  const [search, setSearch] = useState(globalFilter);

  // Search input state handle
  const onSearchChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 100);

  // A function that sets the sorted value for the table
  const setSortedValue = (column) => {
    let sortedValue;

    if (isSorted && column.isSorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else if (isSorted) {
      sortedValue = "none";
    } else {
      sortedValue = false;
    }

    return sortedValue;
  };

  // Setting the entries starting point
  const entriesStart =
    pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;

  // Setting the entries ending point
  let entriesEnd;

  if (pageIndex === 0) {
    entriesEnd = pageSize;
  } else if (pageIndex === pageOptions.length - 1) {
    entriesEnd = rows.length;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }

  const handleOpenMenu = (event, row, index) => {
    setRowAndIndex(row, index);
    setOpenMenu(event.currentTarget);
  };
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = (param) => {
    return (
      <Menu
        anchorEl={openMenu}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={Boolean(openMenu)}
        onClose={handleCloseMenu}
        sx={{ mt: 2 }}
      >
        {children.map((item) => item)}
      </Menu>
    );
  };

  // Styles for the navbar icons
  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = dark.main;

      colorValue = text.main;

      return colorValue;
    },
  });

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      {entriesPerPage || canSearch ? (
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={3}
        >
          {entriesPerPage && (
            <MDBox display="flex" alignItems="center">
              <Autocomplete
                disableClearable
                value={pageSize.toString()}
                options={entries}
                onChange={(_, newValue) => {
                  setEntriesPerPage(parseInt(newValue, 10));
                }}
                size="small"
                sx={{ width: "5rem" }}
                renderInput={(params) => <MDInput {...params} />}
              />
              <MDTypography variant="caption" color="secondary">
                &nbsp;&nbsp;dados por página
              </MDTypography>
            </MDBox>
          )}
          {canSearch && (
            <MDBox width="12rem" ml="auto">
              <MDInput
                placeholder="Pesquisar..."
                value={search}
                size="small"
                fullWidth
                onChange={({ currentTarget }) => {
                  setSearch(search);
                  onSearchChange(currentTarget.value);
                }}
              />
            </MDBox>
          )}
        </MDBox>
      ) : null}
      <Table {...getTableProps()}>
        <MDBox component="thead">
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                if (
                  column.Header !== "UUID" &&
                  column.Header !== "StatusCompanyUser" &&
                  column.Header !== "StatusCooperated" &&
                  column.Header !== "StatusFollowUp"
                ) {
                  return (
                    <DataTableHeadCell
                      {...column.getHeaderProps(
                        isSorted && column.getSortByToggleProps()
                      )}
                      width={column.width ? column.width : "auto"}
                      align={column.align ? column.align : "left"}
                      sorted={setSortedValue(column)}
                    >
                      {column.render("Header")}
                    </DataTableHeadCell>
                  );
                } else if (
                  column.Header === "StatusCooperated" ||
                  column.Header === "StatusCompanyUser" ||
                  column.Header === "StatusFollowUp"
                ) {
                  return (
                    <DataTableHeadCell
                      {...column.getHeaderProps(
                        isSorted && column.getSortByToggleProps()
                      )}
                      width={column.width ? column.width : "auto"}
                      align={column.align ? column.align : "left"}
                      sorted={setSortedValue(column)}
                    >
                      {"STATUS"}
                    </DataTableHeadCell>
                  );
                }
              })}
            </TableRow>
          ))}
        </MDBox>
        <TableBody {...getTableBodyProps()}>
          {page.map((row, key) => {
            prepareRow(row);
            return (
              <TableRow {...row.getRowProps()}>
                {row.cells.map((cell, i) => {
                  if (cell.getCellProps().key.includes("action")) {
                    return (
                      <DataTableBodyCell
                        noBorder={noEndBorder && rows.length - 1 === key}
                        align={"right"}
                        {...{ key: "cell_0_action", role: "cell" }}
                      >
                        {cell.row?.allCells[7]?.column?.Header ===
                        "StatusCooperated" ? (
                          cell?.row?.values?.status === 4 ||
                          cell?.row?.values?.status === 7 ? (
                            <MDBox color={"inherit"}>
                              <IconButton
                                style={{ verticalAlign: "top" }}
                                size="small"
                                disableRipple
                                color="inherit"
                                sx={navbarIconButton}
                                aria-controls="notification-menu"
                                aria-haspopup="true"
                                variant="contained"
                                onClick={(event) =>
                                  handleOpenMenu(event, row, key)
                                }
                              >
                                <Icon sx={iconsStyle}>create</Icon>
                              </IconButton>
                              {renderMenu()}
                            </MDBox>
                          ) : (
                            <></>
                          )
                        ) : (
                          <MDBox color={"inherit"}>
                            <IconButton
                              style={{ verticalAlign: "top" }}
                              size="small"
                              disableRipple
                              color="inherit"
                              sx={navbarIconButton}
                              aria-controls="notification-menu"
                              aria-haspopup="true"
                              variant="contained"
                              onClick={(event) =>
                                handleOpenMenu(event, row, key)
                              }
                            >
                              <Icon sx={iconsStyle}>create</Icon>
                            </IconButton>
                            {renderMenu()}
                          </MDBox>
                        )}
                      </DataTableBodyCell>
                    );
                  } else if (
                    !cell.getCellProps().key.includes("uuid") &&
                    !cell.getCellProps().key.includes("status") &&
                    !cell.getCellProps().key.includes("pa_id")
                  ) {
                    return (
                      <DataTableBodyCell
                        noBorder={noEndBorder && rows.length - 1 === key}
                        align={cell.column.align ? cell.column.align : "left"}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </DataTableBodyCell>
                    );
                  } else if (cell.column.Header === "StatusCooperated") {
                    return (
                      <DataTableBodyCell
                        noBorder={noEndBorder && rows.length - 1 === key}
                        align={cell.column.align ? cell.column.align : "left"}
                        {...cell.getCellProps()}
                      >
                        {statusCooperatedBadge(cell?.row?.values?.status)}
                      </DataTableBodyCell>
                    );
                  } else if (cell.column.Header === "StatusFollowUp") {
                    return (
                      <DataTableBodyCell
                        key={i}
                        noBorder={noEndBorder && rows.length - 1 === key}
                        align={cell.column.align ? cell.column.align : "left"}
                        {...cell.getCellProps()}
                      >
                        {statusFollowUpBadge(cell?.row?.values, i)}
                      </DataTableBodyCell>
                    );
                  } else if (cell.column.Header === "StatusCompanyUser") {
                    return (
                      <DataTableBodyCell
                        noBorder={noEndBorder && rows.length - 1 === key}
                        align={cell.column.align ? cell.column.align : "left"}
                        {...cell.getCellProps()}
                      >
                        {statusCompanyUserBadge(cell?.row?.values?.status)}
                      </DataTableBodyCell>
                    );
                  }
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <MDBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
      >
        {showTotalEntries && (
          <MDBox mb={{ xs: 3, sm: 0 }}>
            <MDTypography
              variant="button"
              color="secondary"
              fontWeight="regular"
            >
              Mostrando do {entriesStart} ao {entriesEnd}{" "}
              {rows.length === 1 ? "de" : "dos"} {rows.length}{" "}
              {rows.length === 1 ? "dado" : "dados"}
            </MDTypography>
          </MDBox>
        )}
        {pageOptions.length > 1 && (
          <MDPagination
            variant={pagination.variant ? pagination.variant : "gradient"}
            color={pagination.color ? pagination.color : "info"}
          >
            {canPreviousPage && (
              <MDPagination item onClick={() => previousPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
              </MDPagination>
            )}
            {renderPagination.length > 6 ? (
              <MDBox width="5rem" mx={1}>
                <MDInput
                  inputProps={{
                    type: "number",
                    min: 1,
                    max: customizedPageOptions.length,
                  }}
                  value={customizedPageOptions[pageIndex]}
                  onChange={(handleInputPagination, handleInputPaginationValue)}
                />
              </MDBox>
            ) : (
              renderPagination
            )}
            {canNextPage && (
              <MDPagination item onClick={() => nextPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
              </MDPagination>
            )}
          </MDPagination>
        )}
      </MDBox>
    </TableContainer>
  );
}

// Setting default values for the props of DataTable
DataTable.defaultProps = {
  entriesPerPage: { defaultValue: 10, entries: [5, 10, 15, 20, 25] },
  canSearch: false,
  showTotalEntries: true,
  pagination: { variant: "gradient", color: "info" },
  isSorted: true,
  noEndBorder: false,
};

// Typechecking props for the DataTable
DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      defaultValue: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  canSearch: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
};

export default DataTable;
